"use client";

import React, { useEffect, useState, useRef } from "react";
import "./PerscriptionLayout.css";
import { Image } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentDoctor } from "../../../authDoctor/redux/thunks/doctorsThunks";
import { useTranslation } from "react-i18next";
import { usePrescriptionLayout } from "../../../prescriptions/hooks/usePrescriptionLayout";
import useDoctorInformation from "../../../ProfileDoctor/hooks/useDoctorInformation";

import setupIcon from "../../../assets/icons/setup.png";
import log1 from "../../../assets/icons/log1.png";
import log2 from "../../../assets/icons/log2.png";
import log3 from "../../../assets/icons/log3.png";
import log4 from "../../../assets/icons/log4.png";
import log5 from "../../../assets/icons/log5.png";
import log6 from "../../../assets/icons/log6.png";
import log7 from "../../../assets/icons/log7.png";
import log8 from "../../../assets/icons/log8.png";
import log9 from "../../../assets/icons/log9.png";
import log10 from "../../../assets/icons/log10.png";
import log11 from "../../../assets/icons/log11.png";
import log12 from "../../../assets/icons/log12.png";
import log13 from "../../../assets/icons/log13.png";
import log14 from "../../../assets/icons/log14.png";
import log15 from "../../../assets/icons/log15.png";
import log16 from "../../../assets/icons/log16.png";

/* ------------ Grille logos ------------ */
const ROWS = [
  [log1, log2, log3, log4, log5, log6],
  [log7, log8, log9, log10, log11, log12],
  [log13, log14, log15, log16],
];

/* --- Mapping des spécialités EN -> AR --- */
const SPECIALTY_AR = {
  Cardiology: "طب القلب",
  Dermatology: "طب الجلد",
  Neurology: "طب الأعصاب",
  Pediatrics: "طب الأطفال",
  Radiology: "الأشعة",
  Oncology: "علم الأورام",
  Orthopedics: "جراحة العظام",
  Psychiatry: "الطب النفسي",
  "General Practitioner": "طبيب عام",
  Endocrinology: "طب الغدد الصماء",
  Gastroenterology: "طب الجهاز الهضمي",
  Ophthalmology: "طب العيون",
  Gynecology: "طب النساء",
  Urology: "طب المسالك البولية",
  Dentistry: "طب الأسنان",
};

/* --- Translittération Français -> Arabe --- */
const TRANSLIT_MAP = {
  eau: "و",
  oua: "وا",
  oul: "ول",
  our: "ور",
  ain: "ان",
  ein: "ان",
  ou: "و",
  ai: "ا",
  ei: "ي",
  au: "و",
  oi: "وا",
  ch: "ش",
  ph: "ف",
  qu: "ك",
  gn: "ني",
  th: "ت",
  kh: "خ",
  dh: "ذ",
  gh: "غ",
  ss: "س",
  ll: "ل",
  rr: "ر",
  mm: "م",
  nn: "ن",
  tt: "ت",
  bb: "ب",
  dd: "د",
  ff: "ف",
  pp: "ب",
  el: "ال",
  al: "ال",
  ab: "عب",
  ah: "ه",
  ih: "ه",
  eh: "ه",
  a: "ا",
  b: "ب",
  c: "ك",
  d: "د",
  e: "ي",
  f: "ف",
  g: "ج",
  h: "ه",
  i: "ي",
  j: "ج",
  k: "ك",
  l: "ل",
  m: "م",
  n: "ن",
  o: "و",
  p: "ب",
  q: "ق",
  r: "ر",
  s: "س",
  t: "ت",
  u: "و",
  v: "ف",
  w: "و",
  x: "كس",
  y: "ي",
  z: "ز",
  " ": " ",
  ".": ".",
  "-": "-",
  é: "ي",
  è: "ي",
  ê: "ي",
  ë: "ي",
  à: "ا",
  â: "ا",
  î: "ي",
  ï: "ي",
  ô: "و",
  û: "و",
  ù: "و",
  ç: "س",
};

const transliterateToArabic = (text) => {
  if (!text) return "";
  let result = "";
  const lowerText = text.toLowerCase();
  let i = 0;
  while (i < lowerText.length) {
    const threeChar = lowerText.slice(i, i + 3);
    if (TRANSLIT_MAP[threeChar]) {
      result += TRANSLIT_MAP[threeChar];
      i += 3;
    } else {
      const twoChar = lowerText.slice(i, i + 2);
      if (TRANSLIT_MAP[twoChar]) {
        result += TRANSLIT_MAP[twoChar];
        i += 2;
      } else {
        const oneChar = lowerText[i];
        result += TRANSLIT_MAP[oneChar] || oneChar;
        i += 1;
      }
    }
  }
  return result;
};

/* --- Palette --- */
const PALETTE = [
  "#1e1e1e",
  "#2B2F36",
  "#1e1e1e",
  "#546881",
  "#718096",
  "#A0AEC0",
  "#CBD5E0",
  "#E2E8F0",
  "#0F3D0F",
  "#1A4D1A",
  "#2F855A",
  "#38A169",
  "#48BB78",
  "#68D391",
  "#9AE6B4",
  "#E6FFFA",
  "#0B2A5B",
  "#123D82",
  "#2f7fb0",
  "#006eea ",
  "#3B82F6",
  "#60A5FA",
  "#93C5FD",
  "#DBEAFE",
  "#4A0C0C",
  "#6B1111",
  "#991B1B",
  "#B91C1C",
  "#DC2626",
  "#EF4444",
  "#FCA5A5",
  "#FEE2E2",
  "#4D1F00",
  "#6B3100",
  "#92400E",
  "#B45309",
  "#D97706",
  "#F59E0B",
  "#FBBF24",
  "#FDE68A",
];

const LAYOUT_DRAFT_KEY = "medilink_prescription_layout_draft";
const defaultAvatar = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export default function PrescriptionLayout({ onConfirm = () => {} }) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || "").startsWith("ar");
  const fileInputRef = useRef(null);
  const designInputRef = useRef(null);

  // Redux
  const { user: currentUser } = useSelector((state) => state.doctor || {});
  const { avatarSrc } = useDoctorInformation(currentUser);

  const {
    currentDoctor,
    layout,
    status,
    error,
    saveLayout,
    saveStatus,
    saveError,
  } = usePrescriptionLayout();

  const [activeTab, setActiveTab] = useState("logotype");

  const [selectedLogo, setSelectedLogo] = useState(null);
  const [confirmedLogo, setConfirmedLogo] = useState(null);
  const [customLogos, setCustomLogos] = useState([]);
  const [uploadedDesign, setUploadedDesign] = useState(null);

  const [paletteMode, setPaletteMode] = useState("text");
  const [iconColor, setIconColor] = useState("#1e1e1e");
  const [textColor, setTextColor] = useState("#546881");
  const [confirmedPalette, setConfirmedPalette] = useState(null);

  const [doctorInfo, setDoctorInfo] = useState({
    fullName: "",
    fullNameAr: "",
    specialty: "",
    specialtyAr: "",
    phone: "",
    email: "",
    address: "",
    addressAr: "",
  });
  const [confirmedDoctorInfo, setConfirmedDoctorInfo] = useState(null);

  // Fetch doctor on mount
  useEffect(() => {
    dispatch(getCurrentDoctor());
  }, [dispatch]);

  useEffect(() => {
    const base = {
      fullName: currentDoctor?.fullName || "",
      fullNameAr: currentDoctor?.fullName
        ? transliterateToArabic(currentDoctor.fullName)
        : "",
      specialty: currentDoctor?.specialty || "General Practitioner",
      specialtyAr: currentDoctor?.specialty
        ? SPECIALTY_AR[currentDoctor.specialty] || currentDoctor.specialty
        : SPECIALTY_AR["General Practitioner"],
      phone: currentDoctor?.phone || "",
      email: currentDoctor?.email || "",
      address: currentDoctor?.clinicAddress || "",
      addressAr: "",
    };

    let draft = null;
    try {
      const raw = localStorage.getItem(LAYOUT_DRAFT_KEY);
      draft = raw ? JSON.parse(raw) : null;
    } catch {
      draft = null;
    }

    const draftDoctorInfo =
      draft?.doctorInfo || {
        fullName: draft?.fullName,
        fullNameAr: draft?.fullNameAr,
        specialty: draft?.specialty,
        specialtyAr: draft?.specialtyAr,
        phone: draft?.phone,
        email: draft?.email,
        address: draft?.address,
        addressAr: draft?.addressAr,
      };

    if (layout?.logoUrl) setConfirmedLogo(layout.logoUrl);
    if (layout?.couleurTexte) setTextColor(layout.couleurTexte);
    if (layout?.couleurLogo) setIconColor(layout.couleurLogo);

    setConfirmedPalette({
      iconColor: layout?.couleurLogo || "#1e1e1e",
      textColor: layout?.couleurTexte || "#546881",
    });

    const mergedDoctorInfo = { ...base, ...(draftDoctorInfo || {}) };

    Object.keys(mergedDoctorInfo).forEach((k) => {
      if (mergedDoctorInfo[k] === undefined || mergedDoctorInfo[k] === null)
        mergedDoctorInfo[k] = "";
    });

    setDoctorInfo(mergedDoctorInfo);
    setConfirmedDoctorInfo(draftDoctorInfo || mergedDoctorInfo);

    try {
      const initialDraft = {
        logoUrl: (draft?.logoUrl ?? layout?.logoUrl) || null,
        couleurTexte: (draft?.couleurTexte ?? layout?.couleurTexte) || "#546881",
        couleurLogo: (draft?.couleurLogo ?? layout?.couleurLogo) || "#1e1e1e",
        ...mergedDoctorInfo,
        doctorInfo: mergedDoctorInfo,
        description:
          layout?.description ||
          (currentDoctor
            ? `Template d'ordonnance du Dr ${currentDoctor.fullName}`
            : "Template d'ordonnance"),
      };
      localStorage.setItem(LAYOUT_DRAFT_KEY, JSON.stringify(initialDraft));
    } catch (err) {
      console.error("Failed to seed layout draft:", err);
    }
  }, [layout, currentDoctor]);

  const previewTextColor = confirmedPalette?.textColor ?? textColor;

  const handlePickColor = (hex) => {
    if (paletteMode === "icons") setIconColor(hex);
    else setTextColor(hex);
  };

  const setInfo = (key, val) => setDoctorInfo((p) => ({ ...p, [key]: val }));

  const handleConfirm = async () => {
    const finalLogo =
      activeTab === "logotype" ? selectedLogo || confirmedLogo : confirmedLogo;

    if (activeTab === "logotype") {
      if (!selectedLogo && !confirmedLogo) return;
      if (selectedLogo) setConfirmedLogo(selectedLogo);
    } else if (activeTab === "palette") {
      setConfirmedPalette({ iconColor, textColor });
    } else if (activeTab === "doctorInfo") {
      setConfirmedDoctorInfo(doctorInfo);
    }

    const finalDoctorInfo =
      activeTab === "doctorInfo"
        ? doctorInfo
        : confirmedDoctorInfo || doctorInfo;

    const payload = {
      logoUrl: finalLogo || null,
      couleurTexte: textColor,
      couleurLogo: iconColor,
      fullName: finalDoctorInfo.fullName,
      fullNameAr: finalDoctorInfo.fullNameAr,
      specialty: finalDoctorInfo.specialty,
      specialtyAr: finalDoctorInfo.specialtyAr,
      phone: finalDoctorInfo.phone,
      email: finalDoctorInfo.email,
      address: finalDoctorInfo.address,
      addressAr: finalDoctorInfo.addressAr,
      doctorInfo: finalDoctorInfo,
      description: currentDoctor
        ? `Template d'ordonnance du Dr ${currentDoctor.fullName}`
        : "Template d'ordonnance",
      active: true,
    };

    try {
      localStorage.setItem(LAYOUT_DRAFT_KEY, JSON.stringify(payload));
    } catch (err) {
      console.error("Failed to store layout draft in localStorage:", err);
    }

    try {
      await saveLayout(payload);
    } catch (e) {
      console.error("❌ saveLayout failed:", e);
    }

    onConfirm?.(payload);
  };

  // Upload design handler (pour remplacer l'ordonnance)
  const handleUploadDesignClick = () => {
    designInputRef.current?.click();
  };

  const handleDesignFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const designImage = event.target?.result;
      setUploadedDesign(designImage);
    };
    reader.readAsDataURL(file);
  };

  // Add logo handler
  const handleAddLogoClick = () => {
    fileInputRef.current?.click();
  };

  const handleLogoFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const newLogo = event.target?.result;
      setCustomLogos((prev) => [...prev, newLogo]);
      setSelectedLogo(newLogo);
      // Automatically confirm the logo and update preview
      setConfirmedLogo(newLogo);
    };
    reader.readAsDataURL(file);
  };

  // Save handler
  const handleSaveClick = () => {
    let draft = null;
    try {
      const raw = localStorage.getItem(LAYOUT_DRAFT_KEY);
      if (!raw) {
        console.warn("No layout draft found in localStorage");
        return;
      }
      draft = JSON.parse(raw);
    } catch (err) {
      console.error("Failed to read layout draft from localStorage:", err);
      return;
    }

    if (!draft || typeof draft !== "object") {
      console.warn("Layout draft invalid");
      return;
    }

    saveLayout(draft);
  };

  const handleCancelClick = () => {
    window.location.reload();
  };

  const isLoadingTemplate = status === "loading";
  const isSaving = saveStatus === "loading";
  const previewInfo = confirmedDoctorInfo || doctorInfo;

  const previewFullName =
    previewInfo?.fullName ||
    currentDoctor?.fullName ||
    t("prescriptionLayout.preview.doctorNameFallback");

  const previewFullNameAr =
    previewInfo?.fullNameAr ||
    (previewFullName
      ? transliterateToArabic(previewFullName)
      : t("prescriptionLayout.preview.doctorNameFallbackAr"));

  const previewSpecialty =
    previewInfo?.specialty || currentDoctor?.specialty || "General Practitioner";

  const previewSpecialtyAr =
    previewInfo?.specialtyAr ||
    SPECIALTY_AR[previewSpecialty] ||
    previewSpecialty;

  const previewPhone =
    previewInfo?.phone ||
    currentDoctor?.phone ||
    t("prescriptionLayout.preview.phoneFallback");

  const previewEmail =
    previewInfo?.email ||
    currentDoctor?.email ||
    t("prescriptionLayout.preview.emailFallback");

  const previewAddress =
    previewInfo?.address ||
    currentDoctor?.clinicAddress ||
    t("prescriptionLayout.preview.addressFallback");

  const previewAddressAr =
    previewInfo?.addressAr ||
    t("prescriptionLayout.preview.addressFallbackAr");

  const doctorName =
    currentUser?.fullName || t("prescriptionLayout.submenu.doctorNameFallback");
  const src = avatarSrc || defaultAvatar;

  return (
    <div
      className={`pl-container pl--hero ${isRTL ? "is-rtl" : ""}`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      {isLoadingTemplate && (
        <div className="pl-loading">
          {t("prescriptionLayout.state.loadingTemplate")}
        </div>
      )}
      {error && (
        <div className="pl-error-msg">
          {t("prescriptionLayout.state.error", { error: String(error) })}
        </div>
      )}
      {saveError && (
        <div className="pl-error-msg">
          {t("prescriptionLayout.state.saveError", {
            error: String(saveError),
          })}
        </div>
      )}
      {saveStatus === "loading" && (
        <div className="pl-loading">{t("prescriptionLayout.state.saving")}</div>
      )}

      <div className="pl-body">
        <section className="pl-customize">
          <div className="pl-customize-header">
            <span>{t("prescriptionLayout.customize.title")}</span>

            <div className="pl-tabs">
              <button
                type="button"
                className={`pl-chip ${activeTab === "logotype" ? "active" : ""}`}
                onClick={() => setActiveTab("logotype")}
                aria-pressed={activeTab === "logotype"}
              >
                <span className="pl-chip-ico">
                  <svg className="pl-chip-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <polyline points="21 15 16 10 5 21"/>
                  </svg>
                </span>
                <span className="pl-chip-label">
                  {t("prescriptionLayout.tabs.logotype")}
                </span>
              </button>

              <button
                type="button"
                className={`pl-chip ${activeTab === "palette" ? "active" : ""}`}
                onClick={() => setActiveTab("palette")}
                aria-pressed={activeTab === "palette"}
              >
                <span className="pl-chip-ico">
                  <svg className="pl-chip-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c.55 0 1-.45 1-1 0-.27-.11-.52-.29-.71-.18-.19-.29-.44-.29-.71 0-.55.45-1 1-1h1.17c3.08 0 5.58-2.5 5.58-5.58C20.17 6.48 16.65 2 12 2z"/>
                    <circle cx="6.5" cy="11.5" r="1.5"/>
                    <circle cx="9.5" cy="7.5" r="1.5"/>
                    <circle cx="14.5" cy="7.5" r="1.5"/>
                    <circle cx="17.5" cy="11.5" r="1.5"/>
                  </svg>
                </span>
                <span className="pl-chip-label">
                  {t("prescriptionLayout.tabs.palette")}
                </span>
              </button>

              <button
                type="button"
                className={`pl-chip ${activeTab === "doctorInfo" ? "active" : ""}`}
                onClick={() => setActiveTab("doctorInfo")}
                aria-pressed={activeTab === "doctorInfo"}
              >
                <span className="pl-chip-ico">
                  <svg className="pl-chip-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                </span>
                <span className="pl-chip-label">
                  {t("prescriptionLayout.tabs.doctorInfo")}
                </span>
              </button>
            </div>
          </div>

          <div className="pl-panels">
            {/* Logotype */}
            <div className={`pl-panel ${activeTab === "logotype" ? "show" : "hide"}`}>
              <div className="pl-logotype-title">
                {t("prescriptionLayout.logotype.title")}
              </div>
              <div className="pl-logotype-subtitle">
                {t("prescriptionLayout.logotype.subtitle")}
              </div>

            <div className="pl-add-logo-wrap">
  <button
    className="pl-add-logo-btn"
    type="button"
    onClick={handleAddLogoClick}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
    <span>{t("prescriptionLayout.actions.addLogo")}</span>
  </button>

  <input
    ref={fileInputRef}
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handleLogoFileChange}
  />
</div>

              <div className="pl-logo-rows">
                {ROWS.map((row, ri) => (
                  <div className="pl-logo-row" key={`row-${ri}`}>
                    {row.map((src, i) => (
                      <button
                        key={`${ri}-${i}`}
                        type="button"
                        className={`pl-logo-item ${selectedLogo === src ? "selected" : ""}`}
                        onClick={() => {
                          setSelectedLogo(src);
                          setConfirmedLogo(src);
                        }}
                        aria-pressed={selectedLogo === src}
                      >
                        <img src={src} alt="" />
                      </button>
                    ))}
                  </div>
                ))}
                
                {/* Custom logos row */}
                {customLogos.length > 0 && (
                  <div className="pl-logo-row">
                    {customLogos.map((src, i) => (
                      <button
                        key={`custom-${i}`}
                        type="button"
                        className={`pl-logo-item ${selectedLogo === src ? "selected" : ""}`}
                        onClick={() => {
                          setSelectedLogo(src);
                          setConfirmedLogo(src);
                        }}
                        aria-pressed={selectedLogo === src}
                      >
                        <img src={src} alt="" />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Palette */}
            <div className={`pl-panel ${activeTab === "palette" ? "show" : "hide"}`}>
              <div className="pl-palette-head">
                <div className="pl-logotype-title">
                  {t("prescriptionLayout.palette.title")}
                </div>
                <div className="pl-logotype-subtitle">
                  {t("prescriptionLayout.palette.subtitle")}
                </div>

                <div
                  className="pl-toggle-group"
                  role="tablist"
                  aria-label={t("prescriptionLayout.palette.ariaLabel")}
                >
                  <button
                    type="button"
                    role="tab"
                    aria-disabled="true"
                    className="pl-toggle disabled"
                    disabled
                  >
                    <span className="pl-toggle-ico" aria-hidden />
                    {t("prescriptionLayout.palette.iconsColor")}
                  </button>

                  <button
                    type="button"
                    role="tab"
                    aria-selected={paletteMode === "text"}
                    className={`pl-toggle ${paletteMode === "text" ? "active" : ""}`}
                    onClick={() => setPaletteMode("text")}
                  >
                    <span className="pl-toggle-aa">Aa</span>
                    {t("prescriptionLayout.palette.textColor")}
                  </button>
                </div>
              </div>

              <div
                className="pl-palette-grid"
                role="listbox"
                aria-label={t("prescriptionLayout.palette.colorsAria")}
              >
                {PALETTE.map((hex) => {
                  const selected = (paletteMode === "icons" ? iconColor : textColor) === hex;
                  return (
                    <button
                      key={hex}
                      type="button"
                      className={`pl-color ${selected ? "selected" : ""}`}
                      style={{ backgroundColor: hex }}
                      aria-label={hex}
                      aria-selected={selected}
                      onClick={() => handlePickColor(hex)}
                    />
                  );
                })}
              </div>
            </div>

            {/* Doctor Info */}
            <div className={`pl-panel ${activeTab === "doctorInfo" ? "show" : "hide"}`}>
              <div className="pl-logotype-title">
                {t("prescriptionLayout.doctorInfo.title")}
              </div>
              <div className="pl-logotype-subtitle">
                {t("prescriptionLayout.doctorInfo.subtitle")}
              </div>

              <div className="pl-form">
                <div className="pl-form-grid">
                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.fullName")}
                    </label>
                    <input
                      className="pl-input"
                      value={doctorInfo.fullName}
                      onChange={(e) => setInfo("fullName", e.target.value)}
                      placeholder={t("prescriptionLayout.form.fullNamePh")}
                    />
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.fullNameAr")}
                    </label>
                    <div className="pl-input-row">
                      <input
                        className="pl-input pl-input-ar"
                        dir="rtl"
                        value={doctorInfo.fullNameAr}
                        onChange={(e) => setInfo("fullNameAr", e.target.value)}
                        placeholder={t("prescriptionLayout.form.fullNameArPh")}
                      />
                    </div>
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.specialty")}
                    </label>
                    <input
                      className="pl-input"
                      value={doctorInfo.specialty}
                      onChange={(e) => setInfo("specialty", e.target.value)}
                      placeholder={t("prescriptionLayout.form.specialtyPh")}
                    />
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.specialtyAr")}
                    </label>
                    <div className="pl-input-row">
                      <input
                        className="pl-input pl-input-ar"
                        dir="rtl"
                        value={doctorInfo.specialtyAr}
                        onChange={(e) => setInfo("specialtyAr", e.target.value)}
                        placeholder={t("prescriptionLayout.form.specialtyArPh")}
                      />
                    </div>
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.phone")}
                    </label>
                    <input
                      className="pl-input"
                      value={doctorInfo.phone}
                      onChange={(e) => setInfo("phone", e.target.value)}
                      placeholder={t("prescriptionLayout.form.phonePh")}
                    />
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.email")}
                    </label>
                    <input
                      className="pl-input"
                      value={doctorInfo.email}
                      onChange={(e) => setInfo("email", e.target.value)}
                      placeholder={t("prescriptionLayout.form.emailPh")}
                    />
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.address")}
                    </label>
                    <input
                      className="pl-input"
                      value={doctorInfo.address}
                      onChange={(e) => setInfo("address", e.target.value)}
                      placeholder={t("prescriptionLayout.form.addressPh")}
                    />
                  </div>

                  <div className="pl-field">
                    <label className="pl-label">
                      {t("prescriptionLayout.form.addressAr")}
                    </label>
                    <input
                      className="pl-input pl-input-ar"
                      dir="rtl"
                      value={doctorInfo.addressAr}
                      onChange={(e) => setInfo("addressAr", e.target.value)}
                      placeholder={t("prescriptionLayout.form.addressArPh")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pl-confirm-wrap">
            <button
              className="pl-confirm-btn"
              type="button"
              onClick={handleConfirm}
              disabled={activeTab === "logotype" && !selectedLogo && !confirmedLogo}
            >
              {t("prescriptionLayout.actions.confirm")}
            </button>
          </div>
        </section>

        <section className="pl-preview">
          {uploadedDesign ? (
            <div className="pl-uploaded-design">
              <img src={uploadedDesign} alt="Uploaded Design" />
            </div>
          ) : (
            <div className="pl-sheet">
              <div className="pl-sheet-header">
                <div className="pl-sheet-logo">
                  {confirmedLogo ? <img src={confirmedLogo} alt="" /> : null}
                </div>

                <div className="pl-sheet-ident">
                  <div className="pl-name" style={{ color: previewTextColor }}>
                    {t("prescriptionLayout.preview.drPrefix")} {previewFullName}
                  </div>
                  <div className="pl-role" style={{ color: previewTextColor }}>
                    {previewSpecialty}
                  </div>
                </div>

                <div className="pl-sheet-ident-ar">
                  <div className="pl-name-ar" style={{ color: previewTextColor }}>
                    {t("prescriptionLayout.preview.drPrefixAr")} {previewFullNameAr}
                  </div>
                  <div className="pl-role-ar" style={{ color: previewTextColor }}>
                    {previewSpecialtyAr}
                  </div>
                </div>
              </div>

              <div className="pl-sheet-footer">
                <div className="pl-sheet-line" />
                <div className="pl-footer-rows">
                  <div className="pl-contacts-en" style={{ color: previewTextColor }}>
                    {t("prescriptionLayout.preview.phone")}:{" "}
                    <span className="pl-bidi-ltr">{previewPhone}</span>
                    <br />
                    {t("prescriptionLayout.preview.email")}:{" "}
                    <span className="pl-bidi-ltr">{previewEmail}</span>
                    <br />
                    {t("prescriptionLayout.preview.address")}: {previewAddress}
                  </div>

                  <div className="pl-contacts-ar" style={{ color: previewTextColor }}>
                    <span className="pl-bidi-ltr">{previewPhone}</span>
                    <span className="pl-ar-label">
                      {" "}
                      {t("prescriptionLayout.preview.phoneArSuffix")}
                    </span>
                    <br />
                    {t("prescriptionLayout.preview.emailAr")}:{" "}
                    <span className="pl-bidi-ltr">{previewEmail}</span>
                    <br />
                    {t("prescriptionLayout.preview.addressAr")}: {previewAddressAr}
                  </div>
                </div>
              </div>
            </div>
          )}

{/* Action buttons below prescription */}
<div className="pl-preview-actions">
  <button
    className="pl-action-upload"
    type="button"
    onClick={handleUploadDesignClick}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 15V3M12 3L8 7M12 3L16 7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span>{t("prescriptionLayout.actions.uploadDesign")}</span>
  </button>

  <input
    ref={designInputRef}
    type="file"
    accept="image/*"
    style={{ display: "none" }}
    onChange={handleDesignFileChange}
  />

  <div className="pl-action-group">
    <button
      className="pl-action-save"
      type="button"
      onClick={handleSaveClick}
      disabled={isSaving}
    >
      {isSaving
        ? t("prescriptionLayout.actions.saving")
        : t("prescriptionLayout.actions.save")}
    </button>

    <button
      className="pl-action-cancel"
      type="button"
      onClick={handleCancelClick}
    >
      {t("prescriptionLayout.actions.cancel")}
    </button>
  </div>
</div>

        </section>
      </div>
    </div>
  );
}

